export default {"src":"/_next/static/media/35-icon.687b6d68.svg","height":38,"width":46,"blurWidth":0,"blurHeight":0};